<template>
  <validation-provider
    class="sm:col-span-2 flex"
    tag="div"
    name="terms-of-use"
    mode="passive"
    :rules="rules"
    v-slot="{ errors }"
  >
    <form-checkbox
      class="items-center"
      size="21.5"
      v-model="internalValue"
      data-testid="accept-terms-of-use"
      @change="onInput"
    ></form-checkbox>
    <div class="flex flex-col">
      <div
        class="text-sm font-semibold leading-tight inline-block items-center mt-1"
      >
        <span>I acknowledge and accept the </span>
        <div class="pr-1" v-if="hasTermsOfUse" style="display: inline-block">
          <span
            @click="handleClick"
            class="cursor-pointer underline text-left"
            data-testid="show-terms-of-use"
            :style="`color: ${linkColor}`"
          >
            Terms of Use
          </span>
          <overlay-policy
            v-if="showTermsOfUseOverlay"
            :policyUrl="termsOfUseUrl"
            @close="onClose"
          />
        </div>
        <span class="leading-none text-xl text-red-400">*</span>
      </div>
      <form-alert-msg slot="error" v-if="errors[0]">{{
        errors[0]
      }}</form-alert-msg>
    </div>
  </validation-provider>
</template>

<script>
import { FormAlertMsg, FormCheckbox } from "@/components/Form/";
import { ValidationProvider, extend } from "vee-validate";
import OverlayPolicy from "@/components/Overlay/OverlayPolicy";

extend("checked", (value) => {
  if (!value) {
    return "Please agree to our Terms of Use.";
  }
  return true;
});

export default {
  components: {
    ValidationProvider,
    FormAlertMsg,
    FormCheckbox,
    OverlayPolicy,
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalValue: false,
      showTermsOfUseOverlay: false,
    };
  },
  computed: {
    linkColor() {
      return this.$store.state.config?.colors?.primaryOptionColor || "#51B44F";
    },
    rules() {
      return "checked";
    },
    hasTermsOfUse() {
      return this.$store.getters.hasTermsOfUse;
    },
    termsOfUseUrl() {
      return this.$store.state.settings?.terms_of_use_url || "";
    },
  },
  watch: {
    checked: {
      handler(val) {
        this.internalValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input:field", val);
      if (val) {
        // Trigger: When a user clicks on the check box accepting the Terms of Use.
        this.$gtm.trackEvent({
          event: "form_step",
          step_name: "Accept Terms of Use", // The name of the step the user is at
          step_number: "14", // The number of the step the user is at
        });
      } else {
        // Trigger: When a user clicks on the check box accepting the Terms of Use.
        this.$gtm.trackEvent({
          event: "form_step",
          step_name: "Reject Terms of Use", // The name of the step the user is at
          step_number: "14", // The number of the step the user is at
        });
      }
    },
    handleClick() {
      this.showTermsOfUseOverlay = true;
      this.$telemetry.trackeEvent({
        name: "patient_details.terms_of_use.display",
      });
      this.$gtm.trackEvent({
        event: "terms_of_use_opened",
      });
    },
    onClose() {
      this.showTermsOfUseOverlay = false;
      this.$telemetry.trackEvent({
        name: "patient_details.terms_of_use.close",
      });
      this.$gtm.trackEvent({
        event: "terms_of_use_closed",
      });
    },
  },
};
</script>
